import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAddToCart, useRemoveFromCart } from "../../../hooks/useEditCart";
import {
  useAddToWishlist,
  useRemoveFromWishlist,
} from "../../../hooks/useEditWishlist";
import i18n from "i18next";
import { Box, CircularProgress, Dialog, Typography } from "@mui/material";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchApi } from "../../../api/api";
import { toast } from "react-toastify";
import { PaymentMethod } from "../../Cart/BuyNow/payment-method";
import { useAtomValue } from "jotai";
import { tokenAtom, userAtom } from "../../../store";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { BsCart2 } from "react-icons/bs";
import { MdOutlineFavoriteBorder } from "react-icons/md";
import i18next from "i18next";

interface Props {
  id: number;
  refetch: Function;
  inCart: boolean;
  inWishlist: boolean;
  isFree: boolean;
  enrolled: boolean;
  isAnswered: boolean;
}

const buttonContentStyle = {
  fontSize: "large",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  whiteSpace: "nowrap",
  width: "100%",
  justifyContent: "center",
};

const QuizzButtons: React.FC<Props> = ({
  id,
  refetch,
  inCart,
  inWishlist,
  isFree,
  enrolled,
  isAnswered,
}) => {
  const [open, setOpen] = useState(false);
  const { isLoading: isLoadingAddToCart, mutateAsync: addToCart } =
    useAddToCart();
  const { isLoading: isLoadingRemoveFromCart, mutateAsync: removeFromCart } =
    useRemoveFromCart();
  const { isLoading: isLoadingAddToWishlist, mutateAsync: addToWishlist } =
    useAddToWishlist();
  const {
    isLoading: isLoadingRemoveFromWishlist,
    mutateAsync: removeFromWishlist,
  } = useRemoveFromWishlist();
  const { mutateAsync: BuyFreeQuizz, isLoading: isLoadingBuyFreeQuizz } =
    useMutation((data: any) => fetchApi("/general/payment", "POST", data), {
      onSuccess: () => {
        toast.success(
          i18n.language === "en"
            ? "quizz bought successfully"
            : "تم شراء الاختبار بنجاح"
        );
        navigate(`/global-test/${id}`);
      },
      onError: () =>
        toast.error(
          i18n.language === "en"
            ? "something went wrong"
            : "حدث خطأ أثناء الطلب"
        ),
    });
  const handleBuy = async () => {
    if (isFree) {
      await BuyFreeQuizz({
        id: id,
        type: "globaltest",
        // paymentApproved: true,
        // paymentMethod: {
        //   globalPayment: {
        //     isPaypal: true,
        //   },
        // },
      });
    } else {
      setOpen(true);
    }
  };

  const handleAddToCart = async () => {
    await addToCart({
      cartable_id: id,
      quantity: 1,
      cartable_type: "globaltest",
    });
    refetch();
  };

  const handleRemoveFromCart = async () => {
    await removeFromCart({
      cartable_id: id,
      quantity: 1,
      cartable_type: "globaltest",
    });
    refetch();
  };

  const handleAddToWishlist = async () => {
    await addToWishlist({
      wishlistable_id: id,
      wishlistable_type: "globaltest",
    });
    refetch();
  };

  const handleRemoveFromWishlist = async () => {
    await removeFromWishlist({
      wishlistable_id: id,
      wishlistable_type: "globaltest",
    });
    refetch();
  };
  const handleClose = () => {
    setOpen(false);
  };

  const { t } = useTranslation();
  const token = useAtomValue(tokenAtom);
  const navigate = useNavigate();

  return (
    <>
      <Box
        className="lp-course-buttons container"
        sx={{
          gap: "20px",
          padding: 0,
          margin: 0,
          justifyContent: "space-around",
        }}
      >
        {!isLoadingBuyFreeQuizz ? (
          !enrolled ? (
            <button
              onClick={() => {
                token ? handleBuy() : navigate("/login");
              }}
              className="home-action"
              style={{ marginTop: "20px" }}
            >
              <Typography sx={buttonContentStyle}>
                {isFree ? t("enrollFree") : t("BuyQuizz")}
                <AiOutlineDollarCircle />
              </Typography>
            </button>
          ) : !isAnswered ? (
            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography>
                {i18n.language === "en"
                  ? "this Test is already bought "
                  : "لقد اشتريت هذا الاختبار"}
              </Typography>
              <Link
                className="home-action"
                style={{ marginTop: "20px" }}
                to={`/global-test/${id}`}
                state={{ courseId: id }}
              >
                <Typography sx={buttonContentStyle}>
                  {i18next.language == "en"
                    ? "Go To Test"
                    : "الذهاب الى الاختبار"}
                </Typography>
              </Link>
            </Box>
          ) : (
            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography>
                {i18n.language === "en"
                  ? "this Test is already answered "
                  : "لقد اجبت على هذا الاختبار"}
              </Typography>
              <Link
                className="home-action"
                style={{ marginTop: "20px" }}
                to={`/corrected-test/${id}`}
                state={{ courseId: id }}
              >
                <Typography sx={buttonContentStyle}>
                  {i18next.language == "en"
                    ? "View your result"
                    : "رؤية نتيجتك"}
                </Typography>
              </Link>
            </Box>
          )
        ) : (
          <button className="in__cart" style={{ marginTop: "20px" }}>
            <CircularProgress sx={{ color: "#fff" }} size="1.8rem" />
          </button>
        )}
        {isLoadingAddToCart || isLoadingRemoveFromCart ? (
          <button className="in__cart" style={{ marginTop: "20px" }}>
            <CircularProgress sx={{ color: "#fff" }} size="1.8rem" />
          </button>
        ) : !inCart && !enrolled ? (
          <button
            onClick={() => {
              token ? handleAddToCart() : navigate("/login");
            }}
            className="home-action"
            style={{ marginTop: "20px" }}
          >
            <Typography sx={buttonContentStyle}>
              {t("WishListAddToCart")}
              <BsCart2 />
            </Typography>
          </button>
        ) : (
          inCart &&
          !enrolled && (
            <button
              onClick={() => {
                token ? handleRemoveFromCart() : navigate("/login");
              }}
              className="in__cart"
              style={{ marginTop: "20px" }}
            >
              <Typography sx={buttonContentStyle}>
                {t("removeFromCart")}
                <BsCart2 />
              </Typography>
            </button>
          )
        )}
        {isLoadingAddToWishlist || isLoadingRemoveFromWishlist ? (
          <button className="in__cart" style={{ marginTop: "20px" }}>
            <CircularProgress sx={{ color: "#fff" }} size="1.8rem" />
          </button>
        ) : !inWishlist && !enrolled ? (
          <button
            onClick={() => {
              token ? handleAddToWishlist() : navigate("/login");
            }}
            className="home-action"
            style={{ marginTop: "20px", marginLeft: "5px" }}
          >
            <Typography sx={buttonContentStyle}>
              {t("WishListAddToWishlist")}
              <MdOutlineFavoriteBorder />
            </Typography>
          </button>
        ) : (
          inWishlist &&
          !enrolled && (
            <button
              onClick={() => {
                token ? handleRemoveFromWishlist() : navigate("/login");
              }}
              className="in__cart"
              style={{ marginTop: "20px", marginLeft: "5px" }}
            >
              <Typography sx={buttonContentStyle}>
                {t("removeFromWishlist")}
                <MdOutlineFavoriteBorder />
              </Typography>
            </button>
          )
        )}
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ zIndex: 9999 }}
        transitionDuration={500}
      >
        <PaymentMethod type={"globaltest"} id={id} setOpen={setOpen} />
      </Dialog>
    </>
  );
};

export default QuizzButtons;
